import * as yup from "yup";
import { useTranslation } from "react-i18next";

export const app1922ValidationSchema = () => {
  const { t } = useTranslation();
  return yup
    .object()
    .shape({
      pastApp: yup
        .object()
        .shape({ m02_id: yup.string(), label: yup.string() })
        .nullable()
        .default(undefined)
        .transform((value, originalValue) => {
          if (
            originalValue &&
            typeof originalValue === "object" &&
            Object.keys(originalValue).length === 0
          ) {
            return undefined;
          }
          return value;
        }),
      d50_id: yup.object().required(t("Το πεδίο είναι υποχρεωτικό")),
      boardDate: yup
        .date()
        .required(t("Το πεδίο είναι υποχρεωτικό"))
        .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία")),
      fudocPrakt: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
      fudocIsologismos: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
      fudocWeb: yup.string().nullable(),
      webDate: yup
        .date()
        .nullable()
        .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία")),
      webURL: yup.string().nullable(),
      paperDate: yup
        .date()
        .nullable()
        .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία")),
      paperName: yup.string().nullable(),
      fudocPaper: yup.string().nullable(),
      usageFromDate: yup
        .date()
        .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
        .required(t("Το πεδίο είναι υποχρεωτικό")),
      usageToDate: yup
        .date()
        .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
        .required(t("Το πεδίο είναι υποχρεωτικό"))
        .min(
          yup.ref("usageFromDate"),
          t("Η ημερομηνία πρέπει να είναι μετά την ημερομηνία από χρήση"),
        ),
    })
    .test("webOrPaperFields", "", (value) => {
      const webFieldsFilled =
        !!value.fudocWeb || !!value.webDate || !!value.webURL;
      const paperFieldsFilled =
        !!value.paperDate || !!value.paperName || !!value.fudocPaper;

      if (webFieldsFilled) {
        const allWebFieldsFilled =
          !!value.fudocWeb && !!value.webDate && !!value.webURL;
        if (!allWebFieldsFilled) {
          return new yup.ValidationError(
            t(
              "Αν επιλέξεις ένα από τα πεδία της ιστοσελίδας τότε πρέπει να τα επιλέξεις όλα",
            ),
            undefined,
            "webOrPaperFields",
          );
        }
      }

      if (paperFieldsFilled) {
        const allPaperFieldsFilled =
          !!value.paperDate && !!value.paperName && !!value.fudocPaper;
        if (!allPaperFieldsFilled) {
          return new yup.ValidationError(
            t(
              "Αν επιλέξεις ένα από τα πεδία της εφημερίδας τότε πρέπει να τα επιλέξεις όλα",
            ),
            undefined,
            "webOrPaperFields",
          );
        }
      }

      return true;
    });
};
